module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter12"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch12"
    }
  }, [_vm._v("Creamy Broccoli Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This beautifully colored soup is open to a lot of variations, and the secret to keeping the broccoli bright green is the addition of baking soda to the pot. Try all the variations; they are a great way to serve your family vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons unsalted butter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 medium onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 medium carrots, cut into ½-inch dice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 bunches broccoli (about 1½ pounds), stems trimmed, cut into florets")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 cups chicken or vegetable broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 cup heavy cream (to lower the fat, use whole milk, or add more broth)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("turn a 5- to 7-quart slow cooker on high, add the butter to the insert, and cover until the butter is melted. Add the onion, carrots, and broccoli and toss the vegetables in the butter. Dissolve the baking soda in the broth and add to the vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cook on high for 2½ to 3 hours or on low for 5 to 6 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Season with salt and pepper and stir in the cream. Turn off the slow cooker and let the soup rest for 15 minutes to come to serving temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 6–8")]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "table2"
    }
  }, [_c('table', {
    staticClass: "noindent"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("CURRIED BROCCOLI SOUP")])]), _c('td', [_vm._v("add 2 teaspoons curry powder to the vegetables and butter before adding the broth. Proceed as directed.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("CHEESY BROCCOLI SOUP")])]), _c('td', [_vm._v("with the heavy cream, add 2 cups finely shredded sharp or mild Cheddar cheese.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("BROCCOFLOWER SOUP")])]), _c('td', [_vm._v("use 2 medium heads broccoflower in place of the broccoli.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22394894","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/018-chapter12.vue
// module id = 108
// module chunks = 0